import React, {useState, useEffect, useRef} from 'react'

import NavigationMenuItem from "../../menu-items/menu-item"
import NavigationMenuItemUrl from "../../menu-items/menu-item-url"
import NavigationSection from "../../../../core/model2/navigation/navigation-section"
import {dashboardGroupsMeta} from "../../../../analytics/dashboard/@const"
import NavigationMenu_ReportsLocalSettings from "./local-settings"

type Props = {
    navigationSection?: NavigationSection
}

export default function NavigationMenu_AllReportsItem(props: Props) {
    const localSettings = useRef(new NavigationMenu_ReportsLocalSettings()).current
    const [isExpanded, setIsExpanded] = useState(() => localSettings.allReportsExpanded)
    const [currentRoute, setCurrentRoute] = useState(() => gd.router.history.fragment || '');

    useEffect(() => {
        const onRoute = () => setCurrentRoute(gd.router.history.fragment || '');
        gd.router.on('route', onRoute);
        return () => gd.router.off('route', onRoute);
    }, []);

    const isSelected = currentRoute.includes('o/analytics');

    return (
        <>
            <NavigationMenuItem
                name                    = "All Reports"
                icon                    = "i5-chart-bar"
                url                     = "o/analytics"
                selected                = {isSelected}
                isExpandable            = {true}
                isExpanded              = {isExpanded}
                onMenuItemHandleClick   = {() => {
                    const next = !isExpanded
                    setIsExpanded(next)
                    localSettings.allReportsExpanded = next
                }}
                navigationSection       = {props.navigationSection}
            />
            {isExpanded && _.map(dashboardGroupsMeta, (group) => (
                <NavigationMenuItemUrl
                    key                 = {group.id}
                    level               = {1}
                    name                = {group.title}
                    icon                = {group.icon}
                    url                 = {`o/analytics/${group.id}`}
                    navigationSection   = {props.navigationSection}
                />
            ))}
        </>
    );
}
